module.exports = {"320102002":"梅园新村街道","320102003":"新街口街道","320102005":"玄武门街道","320102007":"锁金村街道","320102008":"红山街道","320102009":"孝陵卫街道","320102010":"玄武湖街道","320102400":"徐庄高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320102.json
// module id = 925
// module chunks = 0